import * as React from 'react'
import { colors } from '../colors'

export type PropsType = {
  size?: number,
  color?: string
}

const FlameFilledIcon = (props: PropsType): React.ReactNode => {
  return (
    <svg
      width={props.size || 16}
      height={props.size || 16}
      viewBox={`0 0 12 ${props.size || 16}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6557 6.81206C11.3958 7.68445 10.5977 8.27842 9.68816 8.31554C11.5072 5.9768 11.0617 2.61717 8.72296 0.798144C8.27749 0.464037 7.79489 0.185615 7.27517 0C7.25661 2.87703 5.66031 4.47332 4.71367 5.75406C3.7856 6.99768 2.65335 8.63109 2.56055 10.4316V10.6357C2.56055 13.587 4.95498 16 7.90625 16C10.8575 16 13.2705 13.6056 13.2705 10.6543C13.2705 9.2065 12.6951 7.83295 11.6557 6.81206Z"
        fill={props.color || colors.orange}/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M9.88092 11.404L7.91563 8L5.95037 11.4039C5.67644 11.7939 5.51562 12.2691 5.51562 12.7819C5.51562 14.1074 6.59014 15.1819 7.91562 15.1819C9.24111 15.1819 10.3156 14.1074 10.3156 12.7819C10.3156 12.2691 10.1548 11.7939 9.88092 11.404Z"
            fill={props.color || colors.orange}/>
    </svg>
  )
}

export default FlameFilledIcon
